<template>
  <div class="organizeSidebar">
    <div class="organizeSidebar-panel">
      <neb-panel title="Properties">
        <template v-slot:controls>
          <div class="organizeSidebar-panel-sort">
            <neb-icon name="sortAlpha"
              height="14px"
              width="14px"
              :class="{ active: propertySort === 'property__name' }"
              @click.native="() => onPropertySortClick('property__name')"
            ></neb-icon>
            <neb-icon name="sortNum"
              height="14px"
              width="14px"
              :class="{ active: propertySort === 'asset_count' }"
              @click.native="() => onPropertySortClick('asset_count')"
            ></neb-icon>
          </div>
        </template>
        <div class="organizeSidebar-panel-tree">
          <neb-form-control>
            <neb-input icon="search"
              placeholder="Search Properties"
              v-model="_propertySearchTerm"
              clearable
              @clear="_propertySearchTerm = ''"
            ></neb-input>
          </neb-form-control>
          <neb-tree :nodes="propertyOptions"
            maxHeight="250px"
            selectable
            :selected="selectedProperties"
            :loading="propertiesLoading"
            @select="onPropertySelect"
          ></neb-tree>
        </div>
      </neb-panel>
    </div>

    <div class="organizeSidebar-panel">
      <neb-panel title="Collections">
        <div class="organizeSidebar-panel-tree">
          <neb-tree :nodes="collectionOptions"
            maxHeight="250px"
            selectable
            singleSelect
            :loading="collectionsLoading"
            :selected="selectedCollection"
            @select="onCollectionSelect"
          ></neb-tree>
        </div>
      </neb-panel>
    </div>

    <div class="organizeSidebar-panel">
      <neb-panel title="Topics">
        <template v-slot:controls>
          <div class="organizeSidebar-panel-sort">
            <neb-icon name="sortAlpha"
              height="14px"
              width="14px"
              :class="{ active: topicSort === 'alpha' }"
              @click.native="() => onTopicSortClick('alpha')"
            ></neb-icon>
            <neb-icon name="sortNum"
              height="14px"
              width="14px"
              :class="{ active: topicSort === 'num' }"
              @click.native="() => onTopicSortClick('num')"
            ></neb-icon>
          </div>
        </template>
        <div class="organizeSidebar-panel-tree">
          <neb-form-control>
            <neb-input icon="search"
              placeholder="Search Topics"
              v-model="_topicSearchTerm"
              clearable
              @clear="_topicSearchTerm = ''"
            ></neb-input>
          </neb-form-control>
          <neb-tree :nodes="topicOptions"
            maxHeight="250px"
            selectable
            :selected="selectedTopics"
            :loading="topicsLoading"
            @select="onTopicSelect"
          ></neb-tree>
        </div>
      </neb-panel>
    </div>

    <div class="organizeSidebar-panel">
      <neb-panel title="Keywords">
        <template v-slot:controls>
          <div class="organizeSidebar-panel-sort">
            <neb-icon name="sortAlpha"
              height="14px"
              width="14px"
              :class="{ active: keywordSort === 'alpha' }"
              @click.native="() => onKeywordSortClick('alpha')"
            ></neb-icon>
            <neb-icon name="sortNum"
              height="14px"
              width="14px"
              :class="{ active: keywordSort === 'num' }"
              @click.native="() => onKeywordSortClick('num')"
            ></neb-icon>
          </div>
        </template>
        <div class="organizeSidebar-panel-tree">
          <neb-form-control>
            <neb-input icon="search"
              placeholder="Search Keywords"
              v-model="_keywordSearchTerm"
              clearable
              @clear="_keywordSearchTerm = ''"
            ></neb-input>
          </neb-form-control>
          <neb-tree :nodes="keywordOptions"
            maxHeight="250px"
            selectable
            :selected="selectedKeywords"
            :loading="keywordsLoading"
            @select="onKeywordSelect"
          ></neb-tree>
        </div>
      </neb-panel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrganizeSidebar',

  props: {
    topicOptions: {
      type: Array,
      default: () => []
    },
    keywordOptions: {
      type: Array,
      default: () => []
    },
    propertyOptions: {
      type: Array,
      default: () => []
    },
    collectionOptions: {
      type: Array,
      default: () => []
    },
    selectedTopics: {
      type: Array,
      default: () => []
    },
    selectedKeywords: {
      type: Array,
      default: () => []
    },
    selectedProperties: {
      type: Array,
      default: () => []
    },
    selectedCollection: {
      type: String,
      default: ''
    },
    topicsLoading: {
      type: Boolean,
      default: false
    },
    keywordsLoading: {
      type: Boolean,
      default: false
    },
    propertiesLoading: {
      type: Boolean,
      default: false
    },
    collectionsLoading: {
      type: Boolean,
      default: false
    },
    topicSearchTerm: {
      type: String,
      default: ''
    },
    keywordSearchTerm: {
      type: String,
      default: ''
    },
    propertySearchTerm: {
      type: String,
      default: ''
    },
    topicSort: {
      type: String,
      default: null
    },
    keywordSort: {
      type: String,
      default: null
    },
    propertySort: {
      type: String,
      default: null
    }
  },

  computed: {
    _topicSearchTerm: {
      get () {
        return this.topicSearchTerm
      },
      set (value) {
        this.$emit('topic-search-term-change', value)
      }
    },
    _keywordSearchTerm: {
      get () {
        return this.keywordSearchTerm
      },
      set (value) {
        this.$emit('keyword-search-term-change', value)
      }
    },
    _propertySearchTerm: {
      get () {
        return this.propertySearchTerm
      },
      set (value) {
        this.$emit('property-search-term-change', value)
      }
    }
  },

  methods: {
    onTopicSelect (value) {
      this.$emit('change',  { key: 'topics', value })
    },
    onKeywordSelect (value) {
      this.$emit('change', { key: 'keywords', value })
    },
    onPropertySelect (value) {
      this.$emit('change', { key: 'customProperties', value })
    },
    onCollectionSelect (value) {
      this.$emit('change', { key: 'collection', value })
    },
    onTopicSortClick (type) {
      this.$emit('sort-topics', type)
    },
    onKeywordSortClick (type) {
      this.$emit('sort-keywords', type)
    },
    onPropertySortClick (type) {
      this.$emit('sort-properties', type)
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.organizeSidebar {
  &-panel {
    &:not(:last-child) {
      margin-bottom: 15px;
    }

    .nebIcon {
      color: $warm-grey;
      cursor: pointer;

      &.active {
        color: $tiffany-blue;
      }
    }

    &-sort {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .nebIcon {
        &:not(:last-child) {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
